var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phoneNumber)?_c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"d-inline"},[_c('img',{staticClass:"mx-1",staticStyle:{"width":"18px"},attrs:{"src":require("../../assets/images/whatsapp.png"),"alt":"whatsapp"},on:{"click":function($event){return _vm.openWhatsApp()}}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f0bd84e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/openWhatsAppAndViber.vue
// module id = 2088
// module chunks = 0